import React, { useState } from 'react';
import { X, Send } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${BACKEND_URL}/api/contacts`, formData);
      toast.success('Message envoyé avec succès! Nous vous répondrons dans les plus brefs délais.', {
        duration: 4000
      });
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error('Error submitting contact:', error);
      toast.error('Erreur lors de l\'envoi du message. Veuillez réessayer.', {
        duration: 4000
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="max-w-2xl mx-auto">
      <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-100">
        <div className="space-y-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="name" className="text-gray-700 font-semibold mb-2 block">
                Nom complet *
              </Label>
              <Input
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={handleChange}
                disabled={loading}
                className="w-full border-gray-300 focus:border-yellow-500 focus:ring-yellow-500"
                placeholder="Jean Dupont"
              />
            </div>
            <div>
              <Label htmlFor="phone" className="text-gray-700 font-semibold mb-2 block">
                Téléphone *
              </Label>
              <Input
                id="phone"
                name="phone"
                type="tel"
                required
                value={formData.phone}
                onChange={handleChange}
                disabled={loading}
                className="w-full border-gray-300 focus:border-yellow-500 focus:ring-yellow-500"
                placeholder="06 12 34 56 78"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="email" className="text-gray-700 font-semibold mb-2 block">
              Email *
            </Label>
            <Input
              id="email"
              name="email"
              type="email"
              required
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
              className="w-full border-gray-300 focus:border-yellow-500 focus:ring-yellow-500"
              placeholder="jean.dupont@example.com"
            />
          </div>

          <div>
            <Label htmlFor="message" className="text-gray-700 font-semibold mb-2 block">
              Message *
            </Label>
            <Textarea
              id="message"
              name="message"
              required
              value={formData.message}
              onChange={handleChange}
              disabled={loading}
              rows={6}
              className="w-full border-gray-300 focus:border-yellow-500 focus:ring-yellow-500 resize-none"
              placeholder="Décrivez votre besoin..."
            />
          </div>

          <Button 
            type="submit" 
            disabled={loading}
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold text-lg py-6 shadow-lg hover:shadow-xl transition-all disabled:opacity-50"
          >
            <Send className="w-5 h-5 mr-2" />
            {loading ? 'Envoi en cours...' : 'Envoyer le message'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
